import { Stack, Box } from "@mui/material";
import { usePackagingListContext } from "../PackagingListContext";
import { ColumnsPopover } from "../Popover/ColumnsPopover";
import { PackagingPopover } from "../Popover/PackagingPopover";
import { useTranslation } from "react-i18next";
import { TitleSearch } from "src/components/Grid/TitleSearch";

export const GridHeader = () => {
    const { t } = useTranslation();
    const { delayedSearchPackaging, resetSearch, totalItems } = usePackagingListContext();

    return (
        <Box sx={{ padding: "0px 32px" }}>
            <Stack direction="row" useFlexGap justifyContent="space-between" alignItems="center">
                <Stack direction="row" useFlexGap gap="12px">
                    <TitleSearch
                        title={t("packagings.all")}
                        search={delayedSearchPackaging}
                        totalItems={totalItems ?? 0}
                        resetSearch={resetSearch}
                    />
                </Stack>
                <Stack direction="row" useFlexGap gap="12px">
                    <ColumnsPopover />
                    <PackagingPopover />
                </Stack>
            </Stack>

            <Stack
                direction="row"
                useFlexGap
                justifyContent="space-between"
                alignItems="center"
                sx={{ marginTop: "32px" }}
            />
        </Box>
    );
};
